const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
};

export function validateRentalForm(form, isRentRequest = false) {
  const requiresImages = !isRentRequest;
  const missingFields = [];

  if (!hasValue(form.title)) missingFields.push('title');
  if (!hasValue(form.price)) missingFields.push('price');
  if (!hasValue(form.category)) missingFields.push('category');
  if (!hasValue(form.area)) missingFields.push('area');
  if (!hasValue(form.city)) missingFields.push('city');
  if (!hasValue(form.date)) missingFields.push('date');
  if (!hasValue(form.bedrooms)) missingFields.push('bedrooms');
  if (!hasValue(form.bathrooms)) missingFields.push('bathrooms');
  if (!isRentRequest && !hasValue(form.postalCode)) missingFields.push('postalCode');
  if (requiresImages && (!Array.isArray(form.images) || form.images.length === 0)) {
    missingFields.push('images');
  }

  return {
    isValid: missingFields.length === 0,
    missingFields,
  };
}
